var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"animated fadeIn"},[_c('div',[_c('warehouse-table',{attrs:{"id":"warehouse","resourceName":"warehouseResourceList","url":_vm.endpoints.findAll,"fields":_vm.fields,"warehouse":_vm.showAllocation}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }